// WHICH ROUNDS A SPECTATOR MAY SEE.
//
// A tournament either shows a round the moment it is paired (`pairingPublish`
// 'auto', the default and what every tournament did before the setting existed)
// or holds it back until the arbiter presses Publish Pairings on the Round
// Management page ('manual'). Manual mode stamps `published: false` on a round as
// it is generated; the button flips it.
//
// Pure and free of both the DOM and Firebase, because four places have to agree
// on the same answer: the Round Management page (js/ui/pairings.js), the
// spectator's copy of a watched tournament (js/app.js), the meta document the
// cloud sync writes (js/services/cloud-sync.js) and — through that document — the
// broadcast (js/utils/broadcast-publish.js).

/**
 * Is this round one a spectator may see?
 *
 * A round with no flag at all counts as published: rounds paired before this
 * setting existed carry none, and they must not go dark.
 */
export function roundIsPublished(round) {
    return !round || round.published !== false;
}

/**
 * How many LEADING rounds of a list a spectator may see.
 *
 * The count stops at the first unpublished round rather than skipping over it:
 * rounds are numbered by position, and standings that leave out round 2 but count
 * round 3 are worse than standings that simply stop at round 1.
 */
export function publishedRoundCount(rounds) {
    if (!Array.isArray(rounds)) return 0;
    const first = rounds.findIndex(r => !roundIsPublished(r));
    return first === -1 ? rounds.length : first;
}
